module.exports = __webpack_public_path__ + "img/webpage.3bf2836a.jpg";